import { lazy, memo, Suspense } from "react";
import { Button } from "react-bootstrap";

const AutoCarousel = lazy(() => import("../common/carousel"));

const CASE_STUDIES = [
    {
      logo: "/abstract-group-logo.webp",
      initiative: "Supported access and insights into the Saudi market",
      approach:
        "Trade delegation participation and establishment of RHQ in Saudi",
      impact: "Among the first 50 companies in the RHQ programme",
    },
    {
      logo: "/MasterPac-Logo.png",
      initiative:
        "Enabled export of packaging solutions to the UK and UAE F&B markets",
      approach: "Established supply chain links and trade partnerships",
      impact: "Enhancing the packaging sector’s global reach",
    },
    {
      logo: "/logo-4.png",
      initiative:
        "Facilitated investment and acquisition of freehold operational UK care homes",
      approach:
        "Supported transaction structuring and health tourism business setup",
      impact: "Expanding healthcare investments across borders",
    },
    {
      logo: "/Quality-Bites-Logo.png",
      initiative:
        "Facilitated an 8-figure Food & Beverage wholesale supply deal",
      approach: "Brokered negotiations between UK and Italian counterparts",
      impact: "Strengthened international food trade",
    },
    {
      logo: "/Zenith.png",
      initiative:
        "Enabled partnership between construction & real estate firms for UAE expansion",
      approach:
        "Supported land acquisition, construction, and sales/letting partnerships",
      impact: "Driving real estate investment growth in the UAE",
    },
    {
      logo: "/pta-logo.png",
      initiative:
        "Facilitated the export of steel gym equipment to the United Kingdom",
      approach: "Connected manufacturers with key buyers in target markets",
      impact: "Strengthening international trade in fitness equipment",
    },
  ];

const CAROUSEL_ITEMS = [
  { imageUrl: "/saudia-1.png" },
  { imageUrl: "/saudia-2.png" },
  { imageUrl: "/saudia-3.png" },
  { imageUrl: "/saudia-4.png" },
  { imageUrl: "/saudia-5.png" },
  { imageUrl: "/saudia-6.png" },
  { imageUrl: "/saudia-7.png" },
  { imageUrl: "/saudia-8.png" },
];

const LOGO_SIZE = 40;
const CAROUSEL_FALLBACK_HEIGHT = 200;

const videoStyle: React.CSSProperties = {
  maxHeight: "350px",
  objectFit: "cover",
};

const carouselContainerStyle: React.CSSProperties = {
  minHeight: `${CAROUSEL_FALLBACK_HEIGHT}px`,
};

const HeroBlock = memo(function HeroBlock() {
  return (
    <div className="custom-ellipse-bg position-relative p-2 p-md-5 landing-bg d-flex flex-column gap-3 justify-items-center text-center">
      <h1 className="px-md-5 px-1 display-5 fw-bold">
        We Connect Your Organisation Globally
      </h1>
      <p className=" px-md-5 px-1 fs-4 fw-semibold">
        Facilitating confidential B2G and G2B connections to achieve your
        strategic goals.
      </p>
      <div>
        <Button>JOIN OUR PROGRAMME</Button>
      </div>
    </div>
  );
});
HeroBlock.displayName = "HeroBlock";

const VideoBlock = memo(function VideoBlock() {
  return (
    <div className="landing-video position-absolute px-md-5  overflow-hidden">
      <video
        style={videoStyle}
        className="w-100 h-100 border border-5 rounded-4"
        muted
        autoPlay
        loop
        playsInline
        poster="/international-trade-placeholder-1.png"
        preload="metadata"
      >
        <source src="/international-business-video.mov" type="video/mp4" />
      </video>
    </div>
  );
});
VideoBlock.displayName = "VideoBlock";

const CaseStudiesSection = memo(function CaseStudiesSection() {
  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Case Studies</h2>
      <div className="row g-4">
        {CASE_STUDIES.map((study) => (
          <div key={study.logo} className="col-md-6">
            <div className="card-bg rounded-4 p-3 border border-2 h-100 d-flex flex-column gap-3">
              <div className="p-2">
                <img
                  src={study.logo}
                  alt={study.initiative}
                  width={LOGO_SIZE}
                  height={LOGO_SIZE}
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="bg-white rounded-4 p-3 flex-grow-1">
                <h5>Initiative</h5>
                <p>{study.initiative}</p>
                <h5>Approach</h5>
                <p>{study.approach}</p>
                <h5>Impact</h5>
                <p>{study.impact}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});
CaseStudiesSection.displayName = "CaseStudiesSection";

const AssociationSection = memo(function AssociationSection() {
  return (
    <div className="container py-4" style={carouselContainerStyle}>
      <h2 className="text-center py-4">In Association With</h2>
      <Suspense fallback={<div style={carouselContainerStyle} />}>
        <AutoCarousel items={CAROUSEL_ITEMS} />
      </Suspense>
    </div>
  );
});
AssociationSection.displayName = "AssociationSection";

function ExecutiveInMembership() {
  return (
    <div className="w-100 h-100">
      <HeroBlock />
      <VideoBlock />
      <CaseStudiesSection />
      <AssociationSection />
    </div>
  );
}

ExecutiveInMembership.displayName = "ExecutiveInMembership";

export default memo(ExecutiveInMembership);
